import { useEffect, useRef } from "react";
// import Board from "../../chessBoard3/components/Board";
import Board, {
  BOARD_DESKTOP_FRAME_OVERHEAD,
} from "../../chessBoard/components/Board";
import { Chess } from "@chesshotel/chesslib";
// import { Chess } from "./chess";
import { convertMoves } from "../../util/moves";
import { useState } from "react";
import { ChessSets } from "@chesshotel/constants";
import { cn } from "@/lib/utils";
import { move2uci, uci2move } from "@chesshotel/gameReview";
import { MoveShort, UciMove } from "@chesshotel/chess";
import { Button } from "../ui/button";
import { useSettings } from "@/redux/settings";
import MoveIcon from "@/components/common/move-icon";
import { MoveType } from "@chesshotel/types";
import pieceStyles from "../../chessBoard/components/Piece.module.css";
import Piece from "@/chessBoard/components/Piece";
import BlogBoardFrame, { blogBoardControlClass } from "./BlogBoardFrame";

// import Puzzle from "@/pages/puzzle";

// const chess = Chess();

function King() {
  return <img width={35} height={35} src="/images/pieces/staunty/wK.svg" />;
}

enum PuzzleState {
  START,
  CORRECT_MOVE,
  INCORRECT_MOVE,
  DONE,
}

export default function ChallengeBoard(props) {
  // const { uciMoves, fen } = props;

  const boardSize = 450;
  const settings = useSettings();
  settings.chessSet = ChessSets.STAUNTY;

  // const [positionIndex, setPositionIndex] = useState(0);

  const [moveIndex, setMoveIndex] = useState(0);

  const [moves, setMoves] = useState<MoveShort[]>(props.moves);
  const [playingWhite, setPlayingWhite] = useState(false);
  const [possibleMoves, setPossibleMoves] = useState({});
  const [fen, setFen] = useState(null);
  const [animate, setAnimate] = useState(false);
  const [lastMove, setLastMove] = useState(null);

  const [startMoveNumber, setStartMoveNumber] = useState(0);

  const [puzzleState, setPuzzleState] = useState(PuzzleState.START);

  const [highLightKey, setHighLightKey] = useState(null);

  const chess = useRef(Chess()).current;

  let statusTitle = <></>;
  let text = <></>;

  switch (puzzleState) {
    case PuzzleState.START:
      statusTitle = (
        <span className="flex items-center gap-1.5">Your turn</span>
      );
      text = <>Find the best move for {playingWhite ? "white" : "black"}</>;

      break;

    case PuzzleState.CORRECT_MOVE:
      statusTitle = (
        <span className="flex items-center gap-1.5">
          <MoveIcon moveType={MoveType.BEST} /> <div>Best move</div>
        </span>
      );
      text = <span>Keep going!</span>;
      break;

    case PuzzleState.INCORRECT_MOVE:
      statusTitle = (
        <span className="flex items-center gap-1.5">
          <MoveIcon moveType={MoveType.MISTAKE} /> <div>Incorrect move</div>
        </span>
      );
      text = <span>Try again</span>;
      break;

    case PuzzleState.DONE:
      statusTitle = (
        <span className="flex items-center gap-1.5">
          <MoveIcon moveType={MoveType.EXCELLENT} /> <div>Congratulations!</div>
        </span>
      );
      text = <span>You have completed the puzzle!</span>;
      break;

    default:
      break;
  }

  // if (correctMove !== null) {
  //   if (correctMove) {
  //     title = (
  //       <div className="flex items-center space-x-2">
  //         <CheckMark /> <div>Best move</div>
  //       </div>
  //     );
  //     text = <span>Keep going!</span>;
  //   } else {
  //     title = <span>Incorrect move</span>;
  //     text = <span>Try again</span>;
  //   }
  // }

  function startPuzzle() {
    if (!props.fen) {
      return;
    }
    const valid = chess.load(props.fen, 1);

    if (!valid) {
      return;
    }
    setPuzzleState(PuzzleState.START);
    setMoveIndex(1);
    setStartMoveNumber(chess.move_number());

    const movesArr = props.moves.split(" ") as UciMove[];
    const moves = movesArr.map((move) => {
      return uci2move(move);
    });

    const firstMove = moves[0];
    chess.move(firstMove);
    setLastMove(firstMove);
    const fen = chess.fen();
    const playingWhite = chess.turn() === "w";

    setPlayingWhite(playingWhite);
    setMoves(moves);

    const possibleMoves = convertMoves(chess.moves({ verbose: true }));

    setPossibleMoves(possibleMoves);
    setAnimate(false);
    setFen(fen);
    window.requestAnimationFrame(() => setAnimate(true));
  }

  // useEffect(() => {
  //   const move = moves[positionIndex];
  //   console.log("move", move);
  //   setFen(move.after);
  // }, [positionIndex]);

  useEffect(() => {
    startPuzzle();
  }, [props.fen]);

  function moveMade(move) {
    if (!moves) {
      return;
    }
    setHighLightKey(null);

    const correctMove = moves[moveIndex];

    if (
      move.from === correctMove.from &&
      move.to === correctMove.to &&
      move.promotion === correctMove.promotion
    ) {
      if (moves.length === moveIndex + 1) {
        setFen(move.fen);
        setPossibleMoves({});
        setPuzzleState(PuzzleState.DONE);
        setMoveIndex(moveIndex + 1);
      } else {
        const nextMove = moves[moveIndex + 1];
        chess.move(move);
        setMoveIndex(moveIndex + 1);

        chess.move(nextMove);
        const fen = chess.fen();
        const nextPossibleMoves = convertMoves(chess.moves({ verbose: true }));
        setTimeout(() => {
          setFen(fen);
          setPossibleMoves(nextPossibleMoves);
          setMoveIndex(moveIndex + 2);
          setLastMove(nextMove);
        }, 300);
        setPuzzleState(PuzzleState.CORRECT_MOVE);
      }
    } else {
      setFen(move.fen);
      setPossibleMoves(possibleMoves);
      setMoveIndex(moveIndex);
      setPuzzleState(PuzzleState.INCORRECT_MOVE);

      setTimeout(() => {
        setFen(fen);
      }, 100);
    }
  }

  function renderMoves() {
    const rows = [];
    let cols = [];
    let index = 1 + startMoveNumber;

    for (let i = 0; i < moveIndex; i++) {
      if (i == 0 && playingWhite) {
        cols.push(<td></td>);
      }

      const move = move2uci(moves[i]);

      let selected = "";

      if (i === moveIndex - 1) {
        selected = "font-semibold";
      }

      cols.push(
        <td>
          <div className={cn("", selected)}>{move}</div>
        </td>,
      );

      if (i == moveIndex - 1) {
        if (i % 2 == 1) {
          cols.push(<td></td>);
        }
      }

      if (cols.length % 2 == 0) {
        rows.push(
          <tr
            className="odd:bg-chess-ui-row [&>td]:h-9 [&>td]:transition-colors"
            key={index}
          >
            <td className="py-0.5 pl-3">{index}</td>
            {cols[0]}
            {cols[1]}
          </tr>,
        );
        cols = [];
        index++;
      }
    }
    return rows;
  }

  return (
    <BlogBoardFrame title={props.title} caption={props.caption}>
      <div className="flex bg-chess-ui-panel">
        <div className="flex bg-chess-ui-surface">
          <Board
            lastMove={lastMove}
            settings={settings}
            fen={fen}
            animate={animate}
            size={boardSize}
            playingWhite={playingWhite}
            possibleMoves={possibleMoves}
            onMoveMade={(move) => moveMade(move)}
            highLightKey={highLightKey}
            edgeColor={props.edgeColor}
            flushTop={Boolean(props.title)}
          />
        </div>
        <div
          className="flex flex-col items-stretch justify-between p-4 min-w-[260px] bg-chess-ui-panel"
          style={{ height: boardSize + BOARD_DESKTOP_FRAME_OVERHEAD + "px" }}
        >
          <div className="flex flex-col justify-between flex-grow overflow-auto">
            <table className="w-full my-0 text-sm border-collapse text-chess-ui-muted">
              <colgroup>
                <col style={{ width: "24%" }} />
                <col style={{ width: "38%" }} />
                <col style={{ width: "38%" }} />
              </colgroup>
              <tbody>{renderMoves()}</tbody>
            </table>
          </div>
          <div className="flex flex-col items-start w-full pb-4 mx-auto">
            <div className="pb-2 text-base font-semibold">{statusTitle}</div>
            <div className="pb-6 text-sm">{text}</div>

            {puzzleState == PuzzleState.DONE ? (
              <Button
                variant="secondary"
                size="sm"
                className={blogBoardControlClass}
                onClick={() => startPuzzle()}
              >
                Restart
              </Button>
            ) : (
              <Button
                variant="secondary"
                size="sm"
                className={blogBoardControlClass}
                onClick={() => {
                  const key = moves[moveIndex].from;
                  setHighLightKey(key);
                }}
              >
                Hint
              </Button>
            )}
          </div>
        </div>
      </div>
    </BlogBoardFrame>
  );
}
